import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6aab4c77"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6aab4c77')) {
      api.createRecord('6aab4c77', component.options)
    } else {
      api.reload('6aab4c77', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6aab4c77", function () {
      api.rerender('6aab4c77', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/three/index.vue"
export default component.exports